import PageTitle from "~/library/PageTitle"
import LoadingWrapper from "~/library/LoadingWrapper"
import CatchCard from "~/library/CatchCard"
import CatchTable from "~/library/CatchTable"
import Pagination from "~/library/Pagination"
import NavigationLink from "~/library/NavigationLink"

import getAppConfig from "~/utils/getAppConfig"
import useFetchResource from "~/hooks/useFetchResource"
import { apiCategories } from "~/routes"
import Category from "~/types/Category"

const CategoriesList = () => {
  const { venueSlug } = getAppConfig()
  const sortingParams = { "q[s]": "line_items_count desc" }

  const {
    data: categories,
    refetch,
    metadata,
    isLoading,
  } = useFetchResource<{ categories: Category[] }, "categories">(
    apiCategories.index.path({ venueSlug }),
    "categories",
    { page: "1", ...sortingParams }
  )

  const handlePageChange = (page: string) => {
    refetch({ page: page, ...sortingParams })
  }

  return (
    <LoadingWrapper isLoading={isLoading}>
      <PageTitle title="Categories" newItemPath="/categories/new" newItemText="New Category" />

      <div className="row">
        <div className="col-12">
          <CatchCard className={"card-dark-theme"}>
            <CatchTable
              data={Array.isArray(categories) ? categories : []}
              emptyMessage="No Categories"
              columns={[
                {
                  key: "name",
                  header: "Name",
                  formatter: (name, data) => (
                    <NavigationLink type="categories" to={`/categories/${data.id}`}>
                      {name}
                    </NavigationLink>
                  ),
                },
                {
                  key: "active",
                  header: "Status",
                  formatter: (active) => (
                    <span className={`badge badge-lg ${active ? "bg-success" : "bg-secondary"}`}>
                      {active ? "Active" : "Inactive"}
                    </span>
                  ),
                },
                {
                  key: "lineItemsCount",
                  header: "Line Items Count",
                  formatter: (count) => count || 0,
                },
              ]}
            />
            {metadata && (
              <Pagination
                metadata={metadata}
                onPageChange={(page: number) => handlePageChange(page.toString())}
              />
            )}
          </CatchCard>
        </div>
      </div>
    </LoadingWrapper>
  )
}

export default CategoriesList
